import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './ProductInfo.style'

const ProductInfoVariationHundred = (props) => {
  const styles = useStyles()
  const { t } = props

  const containerColor = 'rgba(217, 255, 255, 0.9)'
  return (
    <Box
      className={styles.hundredVariantRoot}
      style={{ backgroundColor: containerColor }}
    >
      <Box className={styles.iconContainer}>{props.icon}</Box>
      <Box className={styles.hundredVariantTextContainer}>
        <Typography variant="h4">{t(props.title)}</Typography>
        <Typography variant="body1">{t(props.subtitle)}</Typography>
      </Box>
    </Box>
  )
}

export default ProductInfoVariationHundred
